export const environment = "dev";
export const path = "/workflow"
export const baseURL =
  environment == "prod"
    ? `https://cygnusdatalake.azurewebsites.net/2/api/${environment}`
    : `https://cygnusdatalake.azurewebsites.net/2/api`;
